import {RecordForm} from '../forms/RecordForm';
import {useParams} from 'react-router-dom';
import {useProductLineItem} from '../hooks/useProductLineItem.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";


export const AddPage = () => {
    const {id: productId} = useParams();
    
    const {
        record,
        createRecord,
    } = useProductLineItem(productId || '');

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
